
import { defineComponent, ref, toRefs } from "vue-demi";
import AdmTypography from "@afe/admirals-dev/src/components/AdmTypography";
import AdmButton from "@afe/admirals-dev/src/components/AdmButton";
import { resendActivationEmail } from "../DemoUniversalForm/api";

export default defineComponent({
  name: "success-step",
  components: {
    AdmTypography,
    AdmButton
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    email: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const { config, email } = toRefs(props);
    const loading = ref(false);
    const success = ref(false);

    const onResend = async () => {
      loading.value = true;
      try {
        await resendActivationEmail({
          apiUrl: config.value.apiUrl,
          email: email.value
        });
        success.value = true;
      } catch (e) {}
    };

    return { onResend, loading, success };
  }
});
